import React from 'react';
import ReactModal from 'react-modal';
import ReactDOM from 'react-dom';

interface ModalProps {
  children: any;
  onClose: any;
  isModalOpen: boolean;
  modalWidth?: string;
  el: any;
}

const portalRoot: any = document.getElementById('modal-root');

class Modal extends React.Component<ModalProps> {
  constructor(props: ModalProps) {
    super(props);
    this.state = {};
  }

  static getDerivedStateFromProps = (props, state) => {
    ReactModal.setAppElement(props.el);
    return null;
  };

  componentDidMount = () => {
    portalRoot.appendChild(this.props.el);
  };

  componentWillUnmount = () => {
    portalRoot.removeChild(this.props.el);
  };
  render() {
    const { children, modalWidth, isModalOpen, onClose } = this.props;
    return ReactDOM.createPortal(
      <div className="modal">
        <div className={`modal-content`} style={{ width: `${modalWidth}` }}>
          <div className="modal-body">
            <button type="button" className="close" onClick={onClose}>
              <span aria-hidden="true">&times;</span>
              <span className="sr-only">Close</span>
            </button>
            {children}
          </div>
        </div>
      </div>,
      this.props.el
    );
  }
}

export default Modal;
